import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SkyEmailValidationDirective } from './email-validation.directive';


export class SkyEmailValidationModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        SkyEmailValidationDirective
    ],
    imports: [
        FormsModule
    ],
    exports: [
        SkyEmailValidationDirective
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
